import React from 'react'
import { Slider } from 'antd'
import { SliderMarks, SliderValue } from 'antd/lib/slider'
import { formatCurrency } from 'lib/currencies'
import { connectRange } from 'react-instantsearch-dom'

import FilterWrapper from 'components/UI/Filters/FilterWrapper'
import useMarket from 'hooks/useMarket'

import 'antd/lib/slider/style/index.css'
import styles from './Slider.module.css'

const CustomPriceRangeSlider = ({
  min: initialMin,
  max: initialMax,
  currentRefinement,
  canRefine,
  refine,
}: {
  min: number
  max: number
  canRefine: boolean
  currentRefinement: { min: number; max: number }
  refine: (value: any) => void
}) => {
  const market = useMarket()
  const rounded = (value: number) => Math.floor(value / 100) * 100

  const [stateMin, setStateMin] = React.useState(rounded(initialMin))
  const [stateMax, setStateMax] = React.useState(rounded(initialMax))

  const setMin = (value: number) => setStateMin(rounded(value))
  const setMax = (value: number) => setStateMax(rounded(value))

  const withCurrency = (value: number) =>
    formatCurrency({
      currency: market.defaultCurrency,
      valueInCent: rounded(Number(value)),
    })

  React.useEffect(() => {
    if (canRefine) {
      setMin(currentRefinement.min)
      setMax(currentRefinement.max)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRefinement.min, currentRefinement.max])

  const onSliderChange = (value: SliderValue) => {
    const [min, max] = value as [number, number]
    if (currentRefinement.min !== min || currentRefinement.max !== max) {
      let refineMin = stateMin
      if (stateMin < initialMin) refineMin = min
      refine({ min: refineMin, max: stateMax })
    }
  }

  const onValuesUpdated = (value: SliderValue) => {
    const [min, max] = value as [number, number]
    setMin(min)
    setMax(max)
  }

  const marks: SliderMarks = {
    [initialMin]: withCurrency(initialMin),
    [initialMax]: withCurrency(initialMax),
  }

  return (
    <FilterWrapper>
      <Slider
        className={styles.slider}
        range
        min={initialMin}
        max={initialMax}
        marks={marks}
        value={[
          stateMin || currentRefinement.min,
          stateMax || currentRefinement.max,
        ]}
        onChange={onValuesUpdated}
        onAfterChange={onSliderChange}
        tipFormatter={withCurrency}
      />
    </FilterWrapper>
  )
}

export default connectRange(CustomPriceRangeSlider)
